module.exports = "<app-settings-desktop *ngIf=\"isDesktop\"></app-settings-desktop>\n<app-settings-mobile *ngIf=\"!isDesktop\"></app-settings-mobile>\n"